<template>
    <div class="dashboard">
        <h1>出社時間変更</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
            <div class="l-w5 l-2-20-t--all">
                <div>
                    <h2>日付</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.work_date" type="date" :disabled="flagDisabled">
                    </div>
                    <h2>ドライバーID</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="params.id" type="number" :disabled="flagDisabled">
                    </div>
                    <h2>ドライバー</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.driver_name" type="text" :disabled="flagDisabled">
                    </div>
                    <h2>出勤時間</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="出勤時間" rules="required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.work_time" type="time">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                </div>
                <div>
                    &nbsp;
                </div>
            </div>
            <div class="l-mt6 l-2-00-m--all">
                <div>
                    <button :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="$_modalOpen('updateWorkTimes')">次へ</button>
                </div>
                <div v-if="input.work_time_update == 1">
                    <button :class="`${classButtonStyle}delete`" type="button" @click="$_modalOpen('deleteWorkTimes')">削除する</button>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "date": {
                "required": true,
                "type": String,
            },
            "id": {
                "required": true,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "flagDisabled": true,
                "input": {},
                "params": {
                    "id": this.id,
                    "date": this.date,
                },
            };
        },
        created() {
            this.fetchingDataWorkTimes();
        },
        "methods": {
            modalAction(key) {
                if (key === "updateWorkTimes") {
                    this.handleUpdate();
                } else if (key === "deleteWorkTimes") {
                    this.handleDelete();
                } else if (key === "updateWorkTimes--finished" || key === "deleteWorkTimes--finished") {
                    this.$router.push({ "name": "offices_work_times_list" });
                }
            },
            fetchingDataWorkTimes() {
                // 個別ドライバー出社時間データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/work_times`,
                    this.$_requestConfig("params")
                ).then(response => {
                    this.input = response.data;
                    this.input.work_date = this.params.date;
                }).catch(() => {
                    this.$_modalError("fetchingWorkTimesError");
                });
            },
            handleUpdate() {
                // 個別ドライバー出社時間データ変更
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/work_times/${this.params.id}`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            handleDelete() {
                // 個別ドライバー出社時間データ削除
                common.$_axios.delete(
                    `${common.$_configs.apiUrl}/work_times`,
                    this.$_requestConfig("params")
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
